var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.5V11.81H1.47191V0.5H0.75ZM2.11682 1.51815C2.11442 1.8856 2.14161 2.161 2.19648 2.34865C2.26313 2.57435 2.3488 2.67578 2.49607 2.75439C2.76895 2.89894 3.34649 2.88879 4.19353 2.88372C4.21278 2.66817 4.1815 2.50081 4.11653 2.3664C4.0323 2.19396 3.89033 2.05703 3.68097 1.93886C3.31039 1.73117 2.74008 1.6135 2.11682 1.51815ZM11.1456 2.12296V11.81H11.8675V2.12296H11.1456ZM1.90506 3.34018V4.50668H7.63225V3.34018H1.90506ZM8.0654 3.34018V4.50668H10.7124V3.34018H8.0654ZM7.63225 4.96314V8.96982H8.0654V7.80332H10.7124V7.34686H8.0654V6.18036H10.7124V5.7239H8.0654V4.96314H7.63225ZM2.11658 7.60806C2.11418 7.97322 2.14137 8.24963 2.19599 8.43475C2.26289 8.66298 2.34832 8.76442 2.49583 8.84049C2.76895 8.98504 3.34649 8.97489 4.19353 8.96982C4.21278 8.75427 4.1815 8.58944 4.11653 8.45504C4.03471 8.2826 3.89033 8.14566 3.68097 8.02901C3.31039 7.82107 2.74008 7.70442 2.11658 7.60806ZM1.90506 9.42628V10.5928H7.63225V9.42628H1.90506ZM8.0654 9.42628V10.5928H10.7124V9.42628H8.0654Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon);
export default __webpack_public_path__ + "static/media/bed-icon.f9db995653c533e6c94b85e2f4683f77.svg";
export { ForwardRef as ReactComponent };